$(document).ready(function () {
  // --- Country Setup ---
  const countries = [
    { code: "AL", name: "Albania" }, { code: "AT", name: "Austria" }, { code: "AU", name: "Australia" },
    { code: "BY", name: "Belarus" }, { code: "BE", name: "Belgium" }, { code: "BA", name: "Bosnia and Herzegovina" },
    { code: "BG", name: "Bulgaria" }, { code: "CA", name: "Canada" }, { code: "CN", name: "China" },
    { code: "HR", name: "Croatia" }, { code: "CY", name: "Cyprus" }, { code: "CZ", name: "Czech" },
    { code: "DK", name: "Denmark" }, { code: "EE", name: "Estonia" }, { code: "FO", name: "Faroe Islands" },
    { code: "FI", name: "Finland" }, { code: "FR", name: "France" }, { code: "DE", name: "Germany" },
    { code: "GR", name: "Greece" }, { code: "GL", name: "Greenland" }, { code: "HK", name: "Hong Kong" },
    { code: "HU", name: "Hungary" }, { code: "IS", name: "Iceland" }, { code: "IE", name: "Ireland" },
    { code: "IT", name: "Italy" }, { code: "JP", name: "Japan" }, { code: "LV", name: "Latvia" },
    { code: "LI", name: "Liechtenstein" }, { code: "LT", name: "Lithuania" }, { code: "LU", name: "Luxembourg" },
    { code: "MO", name: "Macao" }, { code: "MY", name: "Malaysia" }, { code: "MC", name: "Monaco" },
    { code: "MT", name: "Malta" }, { code: "NL", name: "Netherlands" }, { code: "NO", name: "Norway" },
    { code: "PL", name: "Poland" }, { code: "PT", name: "Portugal" }, { code: "QA", name: "Qatar" },
    { code: "RO", name: "Romania" }, { code: "SA", name: "Saudi Arabia" }, { code: "RS", name: "Serbia" },
    { code: "SG", name: "Singapore" }, { code: "SK", name: "Slovakia" }, { code: "SI", name: "Slovenia" },
    { code: "ES", name: "Spain" }, { code: "SE", name: "Sweden" }, { code: "CH", name: "Switzerland" },
    { code: "TW", name: "Taiwan" }, { code: "TH", name: "Thailand" }, { code: "TR", name: "Turkey" },
    { code: "UA", name: "Ukraine" }, { code: "UAE", name: "United Arab Emirates" }, { code: "UK", name: "United Kingdom" },
    { code: "US", name: "United States" }, { code: "VA", name: "Vatican City" }, { code: "VN", name: "Vietnam" },
    { code: "REST", name: "Rest Of The World" },
  ];

  const getCountryName = code => {
    const normalized = ({GB: 'UK', AE: 'UAE'})[(code || '').toUpperCase()] || (code || '').toUpperCase();
    const country = countries.find(c => c.code === normalized);
    return country ? country.name : 'Rest Of The World';
  };

  // One controller owns tier discounts. Native theme events and legacy writes
  // queue a fresh market-aware cart read; no update is discarded by a cooldown.
  if (window.mvkCartProgressLoaded) return;
  window.mvkCartProgressLoaded = true;
  const data = document.querySelector('.progress_bar_data');
  if (!data) return;
  const marketCountry = getCountryName(data.dataset.countryCode);
  const allRows = Array.from(document.querySelectorAll('.progress_bar_values'));
  const row = allRows.find(el => el.dataset.country === marketCountry) ||
    allRows.find(el => el.dataset.country === 'Rest Of The World');
  if (!row) return;
  const countryName = row.dataset.country;
  row.classList.add('current-country');
  const progress = $('.cart-discount-progress');
  const currency = data.dataset.currency;
  const rate = Number(window.Shopify && Shopify.currency && Shopify.currency.rate);
  // A missing/nonmatching rate must never mix USD thresholds with local amounts.
  if (!(rate > 0) || Shopify.currency.active !== currency) return;
  const money = amount => theme.Currency.formatMoney(amount, data.dataset.moneyFormat);
  const tierCount = Math.min(3, Math.max(0, Number(row.dataset.tiers)));
  const tiers = Array.from({length: tierCount}, (_, index) => {
    const n = index + 1;
    return {
      threshold: Math.round(Number(row.dataset['baseThreshold' + n]) * rate / 100) * 100,
      text: row.dataset['threshold' + n + 'text'] || '',
      code: row.dataset['threshold' + n + 'code'] || '',
      before: row.dataset['beforetier' + n] || ''
    };
  });
  if (!tiers.length || tiers.some((tier, i) => !(tier.threshold > 0) ||
      (i > 0 && tier.threshold <= tiers[i - 1].threshold))) return;
  progress.attr('data-step', tierCount);
  const positions = tierCount === 1 ? [50] : tierCount === 2 ? [25, 75] : [25, 50, 75];
  progress.find('.threshold').remove();
  tiers.forEach((tier, i) => {
    // Text comes from merchant metaobjects; do not interpolate it as HTML.
    const marker = $('<div>').addClass('threshold threshold-' + (i + 1)).css('left', positions[i] + '%');
    marker.append($('<span>').addClass('price').html(money(tier.threshold)));
    marker.append($('<span>').addClass('main'));
    marker.append($('<span>').addClass('discount').text(tier.text));
    progress.find('.progress-bar-container').append(marker);
  });
  const managedCodes = new Set(allRows.flatMap(el => [1, 2, 3].map(n =>
    (el.dataset['threshold' + n + 'code'] || '').toLowerCase())).filter(Boolean));
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const cartUrl = theme.routes.cart || root + 'cart.js';
  const updateUrl = theme.routes.cartUpdate || root + 'cart/update.js';
  let running = false;
  let pending = false;
  let scheduled = false;
  let lastItems = null;
  let lastDiscountAttempt = null;

  function render(cart) {
    // Match the original feature: qualify using selling prices before cart discounts.
    const total = Number(cart.original_total_price) || 0;
    progress.toggle(total > 0);
    const next = tiers.findIndex(tier => total < tier.threshold);
    const reached = next < 0 ? tiers.length - 1 : next - 1;
    const text = next < 0 ? row.dataset.completedtext :
      tiers[next].before.replace(/\{\{amount_left\}\}/g, money(tiers[next].threshold - total));
    // Existing merchant rich text is intentionally preserved.
    progress.find('.text-code').html(text || '');
    const prevAmount = next > 0 ? tiers[next - 1].threshold : 0;
    const prevPosition = next > 0 ? positions[next - 1] : 0;
    const width = next < 0 ? 100 : prevPosition + (positions[next] - prevPosition) *
      Math.max(0, (total - prevAmount) / (tiers[next].threshold - prevAmount));
    progress.find('#progress').css('width', Math.min(100, width) + '%');
    return reached >= 0 && total > 0 ? tiers[reached].code : '';
  }

  function refreshUpsells(cart) {
    const signature = JSON.stringify(cart.items.map(item => [item.key, item.quantity]));
    if (signature === lastItems) return;
    lastItems = signature;
    const upsellSelector = '#upsell-main-container[data-country="' + countryName + '"]';
    const upsell = $(upsellSelector);
    const section = upsell.first().closest('[id^="shopify-section-"]')[0];
    // Only render the owning section, preserving the previous speed fix.
    if (!section || !upsell.length) return;
    const url = new URL(location.href);
    url.searchParams.set('section_id', section.id.slice('shopify-section-'.length));
    upsell.load(url.href + ' ' + upsellSelector + ' > *', '', function () {
      window.dispatchEvent(new CustomEvent('fetchUpsellItemsDate', {detail: {country: countryName}}));
      upsell.show().addClass('upsell-active');
    });
  }

  async function request(url, options) {
    const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store', ...options});
    if (!response.ok) throw new Error('Cart request failed: ' + response.status);
    const cart = await response.json();
    if (cart.currency !== currency) throw new Error('Cart market currency mismatch');
    return cart;
  }

  async function drain() {
    if (running) return;
    running = true;
    try {
      while (pending) {
        pending = false;
        let cart = await request(cartUrl);
        const wanted = render(cart);
        refreshUpsells(cart);
        const current = (cart.discount_codes || []).map(entry => entry.code).filter(Boolean);
        // Change only codes owned by this feature. Preserve shopper-entered codes.
        const desired = current.filter(code => !managedCodes.has(code.toLowerCase()));
        if (wanted) desired.push(wanted);
        const normalize = codes => codes.map(code => code.toLowerCase()).sort().join(',');
        const attempt = JSON.stringify([cart.original_total_price, cart.items.map(i => [i.key, i.quantity]), normalize(desired)]);
        if (normalize(current) !== normalize(desired) && lastDiscountAttempt !== attempt) {
          // Suppress repeated rejected-code attempts, not newer cart states.
          lastDiscountAttempt = attempt;
          $('.cart-loader-full').show();
          try {
            cart = await request(updateUrl, {method: 'POST', headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({discount: desired.join(',')})});
            render(cart);
            document.dispatchEvent(new Event('cart:build'));
          } finally {
            $('.cart-loader-full').hide();
          }
        }
      }
    } catch (error) {
      console.warn('Cart progress could not refresh', error);
      progress.hide();
    } finally {
      running = false;
      if (pending) schedule();
    }
  }

  function schedule() {
    pending = true;
    if (running || scheduled) return;
    scheduled = true;
    // Coalesce native events and resource notifications from the same write.
    Promise.resolve().then(() => { scheduled = false; drain(); });
  }
  ['ajaxProduct:added', 'cart:updated', 'cart:build'].forEach(name =>
    document.addEventListener(name, schedule));
  if (window.PerformanceObserver) {
    new PerformanceObserver(list => {
      if (list.getEntries().some(entry => ['fetch', 'xmlhttprequest'].includes(entry.initiatorType) &&
          /\/cart\/(add|change|update|clear)\.js(?:[?#]|$)/.test(entry.name))) schedule();
    }).observe({entryTypes: ['resource']});
  }
  // Only the cart's country-specific upsells belong to this controller.
  // PDP complementary products reuse .upsell-main-container for layout.
  $('.mvk-cart-upsell[data-country]').hide().removeClass('upsell-active');
  $('.mvk-cart-upsell[data-country]').filter(function () {return this.dataset.country === countryName;})
    .show().addClass('upsell-active');
  schedule();
});
